<script setup lang="ts">
/** CaBadge — label kecil. Membungkus <UBadge>, radius penuh, kontras terjaga. */
withDefaults(
  defineProps<{
    tone?: 'brand' | 'ok' | 'warn' | 'bad' | 'netral' | 'emas' | 'emas-lembut'
    icon?: string
  }>(),
  { tone: 'netral' }
)

const kelasTone: Record<string, string> = {
  brand: 'bg-brand text-brand-fg',
  ok: 'bg-ok-soft text-ok',
  warn: 'bg-warn-soft text-warn',
  bad: 'bg-bad-soft text-bad',
  netral: 'bg-surface-2 text-muted border border-line',
  // Tema v3: gold cerah SEBAGAI LATAR dengan tinta gelap di atasnya (11,6:1).
  // Jangan pernah membalik ini menjadi teks gold di atas putih — 1,66:1, gagal total.
  emas: 'bg-[var(--ca-cta-bg)] text-[var(--ca-cta-fg)]',
  'emas-lembut': 'bg-brand-soft text-brand border border-brand/30'
}
</script>

<template>
  <UBadge
    :ui="{
      base: [
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1',
        'text-xs font-semibold leading-none',
        kelasTone[tone]
      ].join(' ')
    }"
    color="neutral"
    variant="soft"
  >
    <UIcon v-if="icon" :name="icon" class="size-3.5 shrink-0" />
    <slot />
  </UBadge>
</template>
